import { render, staticRenderFns } from "./work-order-sent-wgzzzx.vue?vue&type=template&id=40d09cd7&scoped=true"
import script from "./work-order-sent-wgzzzx.vue?vue&type=script&lang=js"
export * from "./work-order-sent-wgzzzx.vue?vue&type=script&lang=js"
import style0 from "./work-order-sent-wgzzzx.vue?vue&type=style&index=0&id=40d09cd7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d09cd7",
  null
  
)

export default component.exports